import {
  Activity,
  Ban,
  CheckCircle2,
  FileClock,
  Filter,
  Flame,
  Gauge,
  KeyRound,
  LayoutDashboard,
  ListTree,
  Rss,
  Server,
  Settings,
  ShieldAlert,
  Tags,
  Users,
  type LucideIcon,
} from "lucide-react";
import { PERMISSIONS as P } from "@/lib/permissions";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Shown if the user has any of these (empty = always). */
  anyOf: string[];
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV: NavGroup[] = [
  {
    label: "Giám sát",
    items: [
      { to: "/", label: "Tổng quan", icon: LayoutDashboard, anyOf: [] },
      { to: "/attacks", label: "Tấn công DDoS", icon: ShieldAlert, anyOf: [P.ddosRead] },
      { to: "/traffic", label: "Lưu lượng", icon: Activity, anyOf: [P.telemetryRead] },
    ],
  },
  {
    label: "Luật lọc",
    items: [
      { to: "/rules/blacklist", label: "Blacklist", icon: Ban, anyOf: [P.blacklistRead] },
      { to: "/blackholes", label: "Blackhole", icon: Flame, anyOf: [P.blacklistRead] },
      { to: "/rules/whitelist", label: "Whitelist", icon: CheckCircle2, anyOf: [P.whitelistRead] },
      { to: "/pam", label: "Luật PAM", icon: ListTree, anyOf: [P.pamRead] },
      { to: "/filters", label: "Bộ lọc chống DDoS", icon: Filter, anyOf: [P.filtersRead] },
      { to: "/aliases", label: "Alias", icon: Tags, anyOf: [P.aliasesRead] },
      { to: "/feeds", label: "Nguồn feed", icon: Rss, anyOf: [P.feedsRead] },
    ],
  },
  {
    label: "Hệ thống",
    items: [
      { to: "/nodes", label: "Node", icon: Server, anyOf: [P.nodesRead] },
      { to: "/licenses", label: "License", icon: KeyRound, anyOf: [P.licensesRead] },
      { to: "/access", label: "Phân quyền", icon: Users, anyOf: [P.usersRead] },
      { to: "/audit", label: "Nhật ký thao tác", icon: FileClock, anyOf: [P.auditRead] },
      { to: "/prometheus", label: "Prometheus", icon: Gauge, anyOf: [P.metricsRead] },
      { to: "/settings", label: "Cài đặt", icon: Settings, anyOf: [] },
    ],
  },
];

/**
 * The phone bottom bar's own slots, in order (AppShell): the pages an
 * operator reaches for mid-incident. Everything else, these included, is
 * one tap away under "Thêm".
 */
export const MOBILE_PRIMARY = ["/", "/attacks", "/blackholes", "/rules/blacklist"];

/** Shorter labels where the sidebar's don't fit under a bottom-bar icon. */
export const MOBILE_LABEL: Record<string, string> = {
  "/": "Tổng quan",
  "/attacks": "Tấn công",
  "/blackholes": "Blackhole",
  "/rules/blacklist": "Blacklist",
};

export function allNavItems(): NavItem[] {
  return NAV.flatMap((g) => g.items);
}
